
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29.667","height":"29.667","viewBox":"0 0 29.667 29.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.833 11.125v6.181","fill":"none","stroke":"#faa61a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".34"}}),_c('path',{attrs:{"d":"M14.833 26.466h-7.49c-4.29 0-6.082-3.061-4.005-6.811l3.856-6.95 3.634-6.524c2.2-3.968 5.81-3.968 8.01 0l3.635 6.539 3.857 6.947c2.077 3.745.272 6.811-4.005 6.811h-7.492z","fill":"none","stroke":"#faa61a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.827 21.014h.011","fill":"none","stroke":"#faa61a","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","opacity":".34"}})])
          )
        }
      }
    